// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"99":"5c6638d3","500":"82bb2f36","651":"67eaaadf"}[chunkId] + ".chunk.js";
};